import * as React from 'react';
import { getTabbableElements } from '../functions/focusable.js';
import { mergeRefs } from '../hooks/useMergedRefs.js';
export const FocusTrap = (props) => {
  let { children } = props;
  let childRef = React.useRef();
  let getFirstLastFocusables = () => {
    let elements = getTabbableElements(childRef.current);
    let firstElement = elements[0];
    let lastElement = elements[(elements.length || 1) - 1];
    return [firstElement, lastElement];
  };
  let onFirstFocus = (event) => {
    let [firstElement, lastElement] = getFirstLastFocusables();
    if (event.relatedTarget === firstElement) lastElement?.focus();
    else firstElement?.focus();
  };
  let onLastFocus = (event) => {
    let [firstElement, lastElement] = getFirstLastFocusables();
    if (event.relatedTarget === lastElement) firstElement?.focus();
    else lastElement?.focus();
  };
  return React.createElement(
    React.Fragment,
    null,
    React.createElement('div', {
      tabIndex: 0,
      onFocus: onFirstFocus,
      'aria-hidden': true,
    }),
    React.cloneElement(children, {
      ref: mergeRefs(children.ref, childRef),
    }),
    React.createElement('div', {
      tabIndex: 0,
      onFocus: onLastFocus,
      'aria-hidden': true,
    }),
  );
};
